module.exports = __webpack_public_path__ + "static/media/03_liste.013f30a5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/StickyPhone/medias/03_liste.mp4
// module id = 198
// module chunks = 0